<template>
    <div class="animate-pulse hover:drop-shadow-xl hover:border-gray-500 relative w-full h-32 cursor-pointer border bg-white border-gray-300 rounded-2xl p-5 py-2">
        <i class="ml-3 mt-10 fa-solid fa-spinner animate-spin"></i>
    </div>
</template>